import React, { PropsWithChildren } from "react";
import * as redux from "react-redux";
import appState from "./appState";

export default function AppStateProvider(props: PropsWithChildren<{}>) {
	return <redux.Provider store={appState}>{props.children}</redux.Provider>;
}
